
export default class AbstractPacker {
  unpackData() {}
  packData() {}
}
